export const CardResolveDirection = {
  Left: -1,
  Right: 1,
};

export type CardResolveDirection = (typeof CardResolveDirection)[keyof typeof CardResolveDirection];
